export var reduxKey = '@@collections2';
export var actionKey = '@@COLLECTIONPANEL2';
export var streamId = '@@collections2';
export var COLLECTIONS_PAGE_SIZE = 20;
export var UNDO_TIMEOUT = 5000;
//# sourceMappingURL=constants.js.map